import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { DialogMessage, Text } from '@reservamos/elements';
import { setReserhubDotersUnavailableDialogVisible } from '@/actions/reserhubAccount';

/**
 * Modal shown after unified session ends because Doters data is unavailable for the tenant.
 * Same pattern as SSOAuthDialog (DialogMessage); message + single accept control only.
 * @returns {JSX.Element|null}
 */
export default function ReserhubDotersUnavailableDialog() {
  const dispatch = useDispatch();
  const { t } = useTranslation('notifications');

  /**
   * Hide the dialog by dispatching the action that clears the Doters-unavailable visibility flag.
   */
  const onAccept = () => {
    dispatch(setReserhubDotersUnavailableDialogVisible(false));
  };

  return (
    <DialogMessage
      primaryButton={t('dialog.reserhub_doters_unavailable_accept')}
      onClickPrimary={onAccept}
      showFade
      dialogType="primary"
    >
      <Text>{t('warning.reserhub_doters_unavailable_logout')}</Text>
    </DialogMessage>
  );
}
